import React from 'react';
import Advisor from './Advisor';
import { useConfig } from './default-config';

const Results = ({ score, onClick }: { score: number; onClick: () => void }) => {
    const { images, texts, results, buttons } = useConfig();

    const getResultsFromScore = (score: number) => {
        const minimumResult = results.find(result => {
            return result.pointsMinimum === 0;
        });
        if (!minimumResult) {
            return undefined;
        }
        return results.reduce((result, currentResult) => {
            if (score >= currentResult.pointsMinimum && currentResult.pointsMinimum > result.pointsMinimum) {
                return currentResult;
            }
            return result;
        }, minimumResult);
    };

    const resultTexts = getResultsFromScore(score);

    return (
        <div className="result">
            <div className="result-header">{texts.result}</div>
            <h2 className="h2 result-insurance">{resultTexts?.title}</h2>
            <div className="result-text">{resultTexts?.ingress}</div>
            {resultTexts?.description && <Advisor description={resultTexts.description} />}
            <button type="button" className="btn btn-flat btn-result" onClick={onClick}>
                {buttons.tryAgain}
            </button>
            <img className="result-image" alt={images.resultAlt} src={images.result} />
        </div>
    );
};

export default Results;
